import { environment } from '../environments/environment';

export class Constants {

    public static readonly version: string = 'v1.3.4';

    public static baseUrl: string = environment.baseUrl;
    public static appUrl: string = environment.appUrl;
    public static clientAppUrl: string = environment.clientAppUrl;
    public static loginUrl: string = environment.loginUrl;
    public static imageUrl: string = environment.imageUrl;
    public static apiVersioning: string = "api";
    public static endPoint: string = environment.baseUrl + Constants.apiVersioning;

    //ROUTES
    static routeDashboard: string = "dashboard";
    static routeMy: string = "my";
    static routeManage: string = "manage";

    static routeWork: string = "works";
    static routeProjects: string = "projects";
    static routeProducts: string = "products";
    static routeViewAll: string = "view_all";

    static routeIssues: string = "issues";
    static routeAllIssues: string = "all";

    static ROUTE_PROJECTS: string = "projects";
    static ROUTE_SPRINT: string = "sprint";
    static ROUTE_PROJECTDETAILS: string = "project_detail";

    static ROUTE_LOGIN: string = "login";

    //LINK
    static linkMyDashboard: string = Constants.routeDashboard + '/' + Constants.routeMy;
    static linkManageDashboard: string = Constants.routeDashboard + '/' + Constants.routeManage;

    static linkAllIssues: string = Constants.routeIssues + '/' + Constants.routeAllIssues;

    //COOKIE
    public static cookieUserKey: string = "sdefrdswwe342sdf345sdfsd001fsd";
    public static cookieToken: string = "koosdsdsffsindjakldkfop002adpadd";
    public static userToken: string = "f34sBdf4I003sdfaS5mHkm5Mk4mkIm4k";

    //KEY
    public static userKey: string = "userf34sBdf4I003sdfaS5mHkm5Mk4mkIm4kkey";

    //ERROR_CODE
    static errorText: {
        "4010": "Unauthorized access",
    };

    public static fileType = {
        "pdf": "assets/img/file/pdf.png",
        "txt": "assets/img/file/txt.png",
        "xlsx": "assets/img/file/xls.png",
        "xls": "assets/img/file/xls.png",
        "ppt": "assets/img/file/ppt.png",
        "csv": "assets/img/file/csv.png",
        "doc": "assets/img/file/doc.png",
        "docx": "assets/img/file/doc.png",
        "html": "assets/img/file/html.png",
        "rtf": "assets/img/file/rtf.png",
        "other": "assets/img/file/txt.png"
    }

    //URL
    public static urlTranslate: string = "./assets/translate";
    public static urlUserDefaultImg: string = "./assets/img/user-default.png";

    //EXTENTION
    public static extenstionJson: string = ".json";

    // date and time
    public static dateFormat = 'yyyy-MM-dd';
    public static dateFormatDatepicker = 'yyyy-mm-dd';
    public static dateTimeFormat = 'yyyy-MM-dd hh:mm'

    // USER ROLE
    public static userRoleList = {'1':'ADMIN','2':'ESS','3':'SUPERVISOR'};
    public static adminRoleId = 1;
    public static essRoleId = 2;
    public static supervisorRoleId = 3;

    //QUICK LINKS
    public static quickLink = {
        '0': {'icon':'fa fa-github-square' , 'url':'http://repo.crowderia.com:7575/users/sign_in','name':'Gitlab'},
        '1': {'icon':'fa fa-group' , 'url':'http://crm.crowderia.com/','name':'CRM'},
        // '2': {'icon':'fa fa-bug' , 'url':'http://bugzilla.crowderia.com/','name':'Bugzilla'},
        '2': {'icon':'fa fa-bank' , 'url':'https://www.sampathvishwa.com/SVCClientWeb/ActionController','name':'SampathBank'},
        '3': {'icon':'fa fa-envelope-square' , 'url':'https://webmail.crowderia.com:2096/','name':'Email'},
        '4': {'icon':'fa fa-slack' , 'url':'https://crowderia.slack.com','name':'Slack'},
        '5': {'icon':'fa fa-bar-chart-o' , 'url':'http://124.43.16.33:9000/','name':'SonarQube'},
        '6': {'icon':'fa fa-legal' , 'url':'http://192.168.1.215:8081/','name':'Jenkins'},
        // '8': {'icon':'fa fa-dashboard' , 'url':'http://124.43.16.33:8000/secure/Dashboard.jspa','name':'Jira'},
        // '9': {'icon':'fa fa-cubes' , 'url':'http://124.43.16.33:9675/','name':'Crowd Works'},
    }

    //QUICK ACCESS FOR ESS
    public static quickAccessForEss = {
        '0': {'icon':'fa fa-calendar' , 'url':'leave/applyLeave','name':'Apply Leave'},
        '1': {'icon':'fa fa-calendar-o' , 'url':'leave/viewMyLeaveList','name':'My Leave'},
        '2': {'icon':'fa fa-clock-o' , 'url':'admin/viewOverviewEmployee','name':'My Timesheet'},
    }

    //QUICK ACCESS FOR Supervisor
    public static quickAccessForSupervisor = {
        '0': {'icon':'fa fa-plus' , 'url':'leave/assignLeave','name':'Assign Leave'},
        '1': {'icon':'fa fa-list-alt' , 'url':'leave/viewLeaveList/reset/1','name':'Leave List'},
        '2': {'icon':'fa fa-calendar' , 'url':'leave/applyLeave','name':'Apply Leave'},
        '3': {'icon':'fa fa-calendar-o' , 'url':'leave/viewMyLeaveList','name':'My Leave'},
        '4': {'icon':'fa fa-clock-o' , 'url':'admin/viewOverviewEmployee','name':'My Timesheet'},
    }

    //All Cv Url
    public static allCvsUrl = 'https://drive.google.com/drive/folders/0B_yRBdVx7W4OazhxSWNQcm5OeDA';
    //Folder Min Type In Google
    public static folderMinTypeInGoogle = 'application/vnd.google-apps.folder';
    //Google Folder Ids
    public static driverCvFolderId = '0B-9k9XgsqHuVaHA2Z3lCS0cyanc';
    public static driverBrochureFolderId = '0B-9k9XgsqHuVY09pSTZrbTFFYmc';
    public static driverCrowderiaGeneralFolderId = '0B-9k9XgsqHuVc1dXVUpCQ3BFbEk';
    public static driverCoderStandardFolderId = '0B-9k9XgsqHuVM3RDMW9qUm5HaUE';
    public static driverTeachTalkFolderId = '0B-9k9XgsqHuVcXNDS0Z1dUJRSFE';

    //URLS FOR INT
    public static mainUrl ='http://int.crowderia.com/symfony/web/index.php/';
    public static urlForLeaveRequest = 'leave/viewLeaveRequest/id/';

    //STATUS ID FOR DONE IN TASK
    public static taskStatusDoneId = 5; 

    // task category id for bug
    public static taskCategoryForBug = 1;
}




// WEBPACK FOOTER //
// ./src/app/app.const.ts